import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default async function redirectLoginSign ({ store }) {
  // check auth token
  const authToken = store.state.authToken || await store.dispatch('loadAuthToken', null, { root: true })

  // check for new multi user login
  const redirectToStart = authToken && !store.state.multiUsers.useNewLogin
  if (!redirectToStart) return

  return {...GlobalPrototypes.defaultRoute()}
}
